import * as routesUtils from '../utils/RoutesUtils'
import { API } from '../core/app.routes'
import httpClient from '../core/httpClient'
import commonService from './common.service'

const pdfService = () => {
  const common = commonService()
	return {
		invoicePDF: async (params = {}, targetBlank = true) => {
			let path = routesUtils.getApiPath(API.PDF_INVOICE, { recordId: params.recordId })
			// Dual invoicing: append withoutDiscount query param if specified
			const queryParams = []
			const offset = new Date().getTimezoneOffset() * -1 // Convert to minutes east of UTC (moment format)
			queryParams.push(`offset=${offset}`)
			if (params.hasDisclosure) queryParams.push('hasDisclosure=true')
			if (params.lang) queryParams.push(`lang=${params.lang}`)
			if (params.withoutDiscount) queryParams.push('withoutDiscount=true')
			if (queryParams.length) path += `?${queryParams.join('&')}`
			
			// Generate filename based on version
			const suffix = params.withoutDiscount ? '_no_discount' : ''
			return httpClient.get(path)
				.then((res) => {
          common.downloadLink(`invoice_${params.recordId}${suffix}.pdf`, res.url, targetBlank)
          return res
				})
		},
		// Legacy invoiceADASPDF removed - F-30833
		// invoiceADASPDF: async (params = {}, targetBlank = true) => {
		// 	const path = routesUtils.getApiPath(API.PDF_INVOICE_ADAS, params)
		// 	return httpClient.get(path)
		// 		.then((res) => {
		// 			common.downloadLink(`invoice_${params.recordId}.pdf`, res.url, targetBlank)
		// 			return res
		// 		})
		// },
		estimatePDF: async (params = {}, targetBlank = true) => {
			let path = routesUtils.getApiPath(API.PDF_ESTIMATE, { recordId: params.recordId })
			// Pass the browser's timezone offset so the PDF shows the correct scheduled time
			const queryParams = []
			const offset = new Date().getTimezoneOffset() * -1 // Convert to minutes east of UTC (moment format)
			queryParams.push(`offset=${offset}`)
			if (params.hasDisclosure) queryParams.push('hasDisclosure=true')
			if (params.lang) queryParams.push(`lang=${params.lang}`)
			if (queryParams.length) path += `?${queryParams.join('&')}`
			return httpClient.get(path)
				.then((res) => {
          common.downloadLink(`estimate_${params.recordId}.pdf`, res.url, targetBlank)
          return res
				})
		},
		estimateSupplementPDF: async (params = {}, targetBlank = true) => {
			let path = routesUtils.getApiPath(API.PDF_ESTIMATE_SUPPLEMENT, { recordId: params.recordId })
			const offset = new Date().getTimezoneOffset() * -1
			path += `?offset=${offset}`
			return httpClient.get(path)
				.then((res) => {
          common.downloadLink(`estimate_${params.recordId}.pdf`, res.url, targetBlank)
          return res
				})
		},
		estimatePartsPDF: async (params = {}, targetBlank = true) => {
			let path = routesUtils.getApiPath(API.PDF_ESTIMATE_PARTS, { recordId: params.recordId })
			const offset = new Date().getTimezoneOffset() * -1
			path += `?offset=${offset}`
			return httpClient.get(path)
				.then((res) => {
          common.downloadLink(`estimate_${params.recordId}.pdf`, res.url, targetBlank)
          return res
				})
		},
		workorderPDF: async (params = {}, targetBlank = true) => {
			let path = routesUtils.getApiPath(API.PDF_WORKORDER, { recordId: params.recordId })
			const offset = new Date().getTimezoneOffset() * -1
			path += `?offset=${offset}`
			return httpClient.get(path)
				.then((res) => {
          common.downloadLink(`workorder_${params.recordId}.pdf`, res.url, targetBlank)
          return res
				})
		},
		// Legacy estimateADASPDF removed - F-30833
		// estimateADASPDF: async (params = {}, targetBlank = true) => {
		// 	const path = routesUtils.getApiPath(API.PDF_ESTIMATE_ADAS, params)
		// 	return httpClient.get(path)
		// 		.then((res) => {
		// 			common.downloadLink(`estimate_${params.recordId}.pdf`, res.url, targetBlank)
		// 			return res
		// 		})
		// },
	}
}

export default pdfService
